import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@mui/material';

type TProps = {
  children: JsxNode;
};
export default function ScaledBox({ children }: TProps) {
  const ref = useRef<HTMLDivElement>();
  const [scale, setScale] = useState<number | null>(null);
  const dimensions = 800;

  useEffect(() => {
    const recalculateSize = () => {
      requestAnimationFrame(() => {
        if (!ref.current) {
          return;
        }
        const parent = ref.current.parentElement;
        if (parent) {
          setScale(parent.clientWidth / dimensions);
        }
      });
    };
    recalculateSize();
    window.addEventListener('resize', recalculateSize);
    return () => window.removeEventListener('resize', recalculateSize);
  }, []);

  return (
    <Box
      ref={ref}
      hidden={scale === null}
      sx={{
        width: dimensions,
        height: dimensions,
        overflow: 'hidden',
        boxSizing: 'border-box',
        transformOrigin: 'left top',
        transform: scale !== null ? `scale(${scale})` : '',
      }}
    >
      {children}
    </Box>
  );
}
